module.exports = __webpack_public_path__ + "static/flags/CB-160c161bff854d630267c996ef759066.gif";